import { render, staticRenderFns } from "./WattList.vue?vue&type=template&id=ff6a1e8c&scoped=true"
import script from "./WattList.vue?vue&type=script&lang=js"
export * from "./WattList.vue?vue&type=script&lang=js"
import style0 from "./WattList.vue?vue&type=style&index=0&id=ff6a1e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6a1e8c",
  null
  
)

export default component.exports